export default "<app-menu></app-menu>\n";